import { Box, Typography } from "@mui/material";
import WelcomeCardStyle from "./WelcomeCardStyle";
import { useAppSelector } from "../../../store/hooks";
import { RootState } from "../../../store/store";
import React, { Dispatch, SetStateAction, useEffect } from "react";
import { ReactTyped, Typed } from "react-typed";
import { isFeatureAvailable } from "../../../utils/Utility";
import { useTranslation } from "react-i18next";

interface Props {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isDisabled: boolean;
  setIsDisabled: Dispatch<SetStateAction<boolean>>;
  typed: Typed | undefined;
  setTyped: Dispatch<SetStateAction<Typed | undefined>>;
}

const WelcomeCard: React.FC<Props> = ({
  setIsOpen,
  isDisabled,
  setIsDisabled,
  typed,
  setTyped,
}) => {
  const { userDetails } = useAppSelector((state: RootState) => state.userAuth);
  const { features } = useAppSelector((state: RootState) => state.features);

  const { t } = useTranslation();

  const [time, setTime] = React.useState<string[]>([]);
  const [isAM, setIsAM] = React.useState<boolean>(true);

  useEffect(() => {
    const formatter = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    const currentTime = formatter.format(new Date()).split(/:| /);
    setTime(currentTime);
    setIsAM(currentTime[2] === "AM");
  }, []);

  return (
    <>
      <Box sx={WelcomeCardStyle.welcomeCardContainerStyle}
          id="customerdashboard_welcome-card"
          data-test-id="test-customerdashboard_welcome-card"
          aria-label="Welcome message card"
      >
        <Typography sx={WelcomeCardStyle.welcomeCardTextStyle}
            id="customerdashboard_welcome-text"
            data-test-id="test-customerdashboard_welcome-text"
            aria-label="Personalized greeting text"
        >
          {t("Good")}{" "}
          {isAM
            ? t("Morning")
            : parseInt(time[0]) >= 5 && parseInt(time[0]) < 12
            ? t("evening")
            : t("afternoon")}
          , {userDetails?.customerName}
          {t("! Need help today?")}
        </Typography>
        {/* {isFeatureAvailable({ features, featureCodes: ["insure_assist"] }) ? (
          <ReactTyped
            strings={[
              t("Click here to know your policies"),
              t("Click here to know your due dates"),
              t("Click here to know your claims"),
            ]}
            typeSpeed={40}
            backSpeed={50}
            attr="placeholder"
            loop
            typedRef={setTyped}
          >
            <input
              type="text"
              className="insureAssistSearch"
              style={{
                padding: "10px",
                borderRadius: "50px",
                width: "100%",
                outline: "none",
                border: "1px solid #cccccc",
                fontFamily: `ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI Variable Display", "Segoe UI", Helvetica, "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol"`,
              }}
              onFocus={() => {
                typed?.stop();
                setIsOpen(true);
                setIsDisabled(true);
              }}
              disabled={isDisabled}
            />
          </ReactTyped>
        ) : (
          <></>
        )} */}
      </Box>
    </>
  );
};

export default WelcomeCard;
